import {Injectable} from '@angular/core';
import {CatalogService} from '../../pim/catalog/catalog.service';
import {Observable} from 'rxjs'
import {ApiResponse} from 'compob2b-libs'

@Injectable({
  providedIn: 'root'
})
export class DamCatalogService extends CatalogService {

  get apiUrl() {
    return '/dam-menu';
  }

  updatePositions(changes: {id: number; newParentId: number; newPosition: number}[]): Observable<ApiResponse<void>> {
    // NOTE: positions endpoint is always /catalog/positions, regardless of accessRolesCatalog
    return this.compoApiService.put<{id: number; newParentId: number; newPosition: number}[], void>(`/catalog/positions/dam`, changes);
  }


}
